module.exports = __webpack_public_path__ + "static/media/picto_ordi_et_fleche.9b191b9b.svg";